import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import FormControl from "@mui/material/FormControl";
import {Typography} from "@mui/material";
import Alert from "@mui/material/Alert";
import {apiInstance} from "../../../api/api";
import {Status} from "../../../models/enums";
import PageHeader from "../../../components/layout/page/PageHeader";

// Temporary rollout feature (PFS-10283) — safe to delete this file and its usage in
// SettingsMain.tsx once the beta opt-in rollout is complete.
const DefaultViewSetting: React.FC = () => {
	const {t} = useTranslation();
	const [optIn, setOptIn] = useState<boolean | null>(null);
	const [saveStatus, setSaveStatus] = useState<Status>(Status.IDLE);

	useEffect(() => {
		apiInstance.uiBetaOptInApi.fetchOptIn()
			.then(value => setOptIn(value ?? false))
			// Local display fallback only -- unlike a forced redirect, defaulting the radio
			// selection to Classic on a failed fetch is harmless and lets the section render.
			.catch(() => setOptIn(false));
	}, []);

	const handleChange = (value: boolean) => {
		const previousOptIn = optIn;
		setOptIn(value);
		setSaveStatus(Status.LOADING);
		apiInstance.uiBetaOptInApi.putOptIn(value)
			.then(() => setSaveStatus(Status.SUCCESS))
			.catch(() => {
				setOptIn(previousOptIn);
				setSaveStatus(Status.ERROR);
			});
	};

	if (optIn === null) {
		return null;
	}

	return (
		<>
			<PageHeader>
				<div className={"settings-main_title"}>
					{t("settings.defaultView.title")}
				</div>
			</PageHeader>
			<FormControl>
				<RadioGroup
					row
					value={optIn}
					onChange={e => handleChange(e.target.value === "true")}
					className={"settings-main_select_label"}
				>
					<FormControlLabel value={false}
									  disabled={saveStatus === Status.LOADING}
									  control={<Radio checked={!optIn} sx={{'& .MuiSvgIcon-root': {fontSize: 14}}}/>}
									  label={<Typography sx={{fontSize: 12}}>
										  {t("settings.defaultView.classicLabel")}
									  </Typography>}/>
					<FormControlLabel value={true}
									  disabled={saveStatus === Status.LOADING}
									  control={<Radio checked={optIn} sx={{'& .MuiSvgIcon-root': {fontSize: 14}}}/>}
									  label={<Typography sx={{fontSize: 12}}>
										  {t("settings.defaultView.newLabel")}
									  </Typography>}/>
				</RadioGroup>
			</FormControl>
			{saveStatus === Status.ERROR &&
				<Alert severity="error">{t("settings.defaultView.saveError")}</Alert>}
		</>
	);
};

export default DefaultViewSetting;
